import { render, staticRenderFns } from "./PreadmissionRules.vue?vue&type=template&id=565e8f57&scoped=true&lang=pug"
import script from "./PreadmissionRules.vue?vue&type=script&lang=js"
export * from "./PreadmissionRules.vue?vue&type=script&lang=js"
import style0 from "./PreadmissionRules.vue?vue&type=style&index=0&id=565e8f57&prod&lang=scss"
import style1 from "./PreadmissionRules.vue?vue&type=style&index=1&id=565e8f57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e8f57",
  null
  
)

export default component.exports